<template>
    <form :action=url method="get" @submit="checkForm">
        <div v-if="errors.length">
            <label>{{$lang('Proszę uzupełnić wymagane pola')}}</label>
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </div>
        <br class="col-md-12">
        <div class="form-row">
            <div class="form-group col-md-12 col-lg-12">
                <div class="row">
                    <div class="form-group col-24 col-lg-12">
                        <label for="adresat">{{$lang('Adresat')}}</label>
                        <input class="form-control" id="adresat" name="adresat" v-model="adresat" type="text">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-24 col-lg-12">
                        <label for="dw">{{$lang('DW')}}</label>
                        <input class="form-control" id="dw" name="dw" v-model="dw" type="text">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-24 col-lg-12">
                        <label for="temat">{{$lang('Temat ')}}</label>
                        <input class="form-control" id="temat" name="temat" v-model="temat" type="text">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-24 col-lg-12">
                        <label class="m-0">{{$lang('Treść ')}}</label>
                        <vue-editor id="tresc" :value="tresc" v-model="tresc" type="text"></vue-editor>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 float-right my-2">
                    <button class="btn btn-primary float-right" type="submit">{{$lang('Wyślij')}}</button>
                </div>
            </div>


        </div>
    </form>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    name: 'mail-recipients-index-model',
    // ,
    props: {
        url: {required: true, type: String}
    },
    data() {
        return {
            errors: [],
            adresat: null,
            dw: null,
            temat: null,
            tresc: null
        }
    },
    methods: {
        checkForm: function (e) {
            if (this.adresat && this.temat && this.tresc) {
                return true;
            }

            this.errors = [];

            if (!this.adresat) {
                this.errors.push(this.$lang('Adresat jest wymagany.'));
            }
            if (!this.temat) {
                this.errors.push(this.$lang('Temat jest wymagany.'));
            }
            if (!this.tresc) {
                this.errors.push(this.$lang('Treść jest wymagana.'));
            }

            this.sendForm();
        },
        sendForm: function () {
            axios.get(this.url, {
                tresc: this.tresc
            }).then(function ({data}) {
                return this.tresc;
            }).catch(function (err) {

            });
        }
    }
};
</script>
